import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import ProductDropzone from '../components/ProductImport/ProductDropzone';

const ProductImportPage = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Import Products
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Drag and drop product images to start importing. Add optional product details below.
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <ProductDropzone />
        </Box>
      </Box>
    </Container>
  );
};

export default ProductImportPage;
